import React, { memo } from 'react'
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from "@dnd-kit/utilities";

export function Item(props) {
  const { id, text, source } = props;

  const styleProfile = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
  }

  const styleCatalog = {
    border: '1px dashed blue',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
  }

  const styleSource = (source === "profile") ? styleProfile : styleCatalog;

  return (
    <div id={id} style={styleSource}>
      {text}
    </div>
  );
}

export const Product = memo(function Product(props) {
  const { id, source, text } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: 999
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Item id={props.id} text={text} source={source}/>
    </div>
  );
});